import { render, staticRenderFns } from "./ReviewFutureSlotsDrawer.vue?vue&type=template&id=a8beb18c"
import script from "./ReviewFutureSlotsDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewFutureSlotsDrawer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports